module.exports = __webpack_public_path__ + "media/images/icon_follow_requests-32eaf00987b072b2b12f8015d6a6a250.png";